<template>
  <Modal
    persistent
    destructive
    :title="$t('remove-logo-modal.title')"
    @confirm="emit('submit')"
  >
    <template #activator>
      <IconButton
        :icon-name="IconName.DELETE"
        label="Remove logo"
        class="absolute top-1 right-1"
        :size="ButtonSize.SM"
        :color="ButtonColor.SURFACE_CONTAINER"
      />
    </template>

    <template #body>
      <div class="text-lg text-center md:whitespace-pre-wrap">
        {{ $t('remove-logo-modal.description') }}
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import {
  ButtonColor,
  ButtonSize,
  IconButton,
  IconName,
  Modal,
} from '@exfluential/ui';

const emit = defineEmits<{
  submit: [];
}>();
</script>
